<div class="container">
    <h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>
        {{data.message}}
    </mat-dialog-content>
    <mat-dialog-actions class="actionButtonsContainer">
        <button mat-button mat-dialog-close cdkFocusInitial color="primary">Ok</button>
    </mat-dialog-actions>
</div>